import { useEffect, useState } from 'react'
import { listAgents } from '@/lib/api'
import { mockSchedules } from '@/lib/mockData'
import type { AgentSchedule } from '@/types'
import { DataTable, type Column } from '@/components/ui/DataTable'
import { StatusDot } from '@/components/ui/StatusDot'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

interface Row extends AgentSchedule {
  agentName: string
}

export function SchedulesGlobal() {
  const [rows, setRows] = useState<Row[]>([])

  useEffect(() => {
    listAgents().then((agents) => {
      const nameById = Object.fromEntries(agents.map((a) => [a.id, a.name]))
      setRows(mockSchedules.map((s) => ({ ...s, agentName: nameById[s.agent_id] ?? s.agent_id })))
    })
  }, [])

  const columns: Column<Row>[] = [
    { header: 'Agente', cell: (r) => r.agentName },
    { header: 'Schedule', cell: (r) => r.name },
    { header: 'Cron', cell: (r) => r.cron_expression, mono: true },
    { header: 'Estado', cell: (r) => (r.enabled ? <StatusDot status="ok" showLabel={false} /> : <StatusDot status="inactive" showLabel={false} />) },
    { header: 'Runs', cell: (r) => String(r.run_count), mono: true },
  ]

  return (
    <div>
      <PendingBackendNotice endpoint="GET /schedules" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Schedules — todos los agentes</h1>
      <DataTable columns={columns} rows={rows} getRowKey={(r) => r.id} />
    </div>
  )
}
